import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbDateStruct } from '@cmps/ng-bootstrap';
import { IOption } from '@cmps/ng-select';
import { finalize, tap } from 'rxjs/operators';

import { Util } from '../../common/common.util';
import { PopUpService } from '../../insight/pop-up.service';
import { SearchUserConfigService } from '../../user/search-user.config.service';
import { SearchUserContainerComponent } from '../../user/search-user.container.component';
import { SearchUserDialog } from '../../user/search-user.dialog';
import { User } from '../../user/user.model';
import { TranslationKeyMap } from '../reports.i18n';
import { ReportsService } from '../reports.service';
import { Report2_2Parameters } from '../scatterplot/scatterplot.model';
import { ScatterPlotService } from '../scatterplot/scatterplot.services';
import { isValidDateStruct } from '../td-daily-huddle/td-daily-huddle.reports.component';
import { TdRawAgentDataDates } from '../td-daily-huddle/td-daily-huddle.reports.model';

import {
    Report2x2Parameters,
    Report2x2Result,
} from './report_tbyt-selection.reports.model';

@Component({
    selector: '[cmpsReportsTbytSelection]',
    templateUrl: './report_tbyt-selection.reports.component.html',
    host: {
        class: 'cmps-reports-tbyt_selection',
    },
})
export class ReporTbyTtSelectionComponent implements OnDestroy, OnInit {
    @Input() params: Report2x2Parameters;
    @Input() roleList: IOption[];
    @Input() rawDates: TdRawAgentDataDates;
    @Input() pendingData: boolean;
    @Input() metricsBehaviours: IOption[];
    @Input() metricsOutcomes: IOption[];
    @Output() generated = new EventEmitter<number>();
    @Output() changed = new EventEmitter<boolean>();
    i18n = TranslationKeyMap;
    form: FormGroup;
    lastDateDataModel: NgbDateStruct;
    defaultUser: User;
    outcomeModified: boolean;
    pendingOutcome: boolean;
    pendingBehaviour: boolean;

    constructor(
        private readonly _reportService: ReportsService,
        private _scatterService: ScatterPlotService,
        private _configService: SearchUserConfigService,
        public popUpService: PopUpService,
        private readonly _userSearchDialog: SearchUserDialog,
    ) {}

    ngOnInit(): void {
        this.params.notFound = false;
        this.outcomeModified = false;
        this.pendingBehaviour = false;
        this.pendingOutcome = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        if (this.popUpVisible) {
            this.popUpService.hide();
        }
        this._userSearchDialog.closeAll();
    }

    get popUpVisible(): boolean {
        return (
            this.popUpService.active &&
            this.popUpService.active.componentRef.instance instanceof
                SearchUserContainerComponent
        );
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onSelectUser(e: MouseEvent) {
        const target = e.target as HTMLElement;
        this._configService.excludedRoleIds = [0];
        this._userSearchDialog.openUsingPopUp({
            options: {
                target,
                placement: 'bottom-left',
                containerClass: 'ie-pu-container rp-pu-container rp-forwards',
            },
            close: (user) => {
                if (user) {
                    this.params.selectedUser = {
                        id: user.id,
                        name: `${user.firstName} ${user.lastName}`,
                    };
                    this.changed.next(true);
                    this.params.notFound = false;
                    this._configService.excludedRoleIds = null;
                }
            },
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onGenerateReport() {
        if (!this.isDone) {
            return;
        }
        this.params.pendingData = true;

        this.params.noData = false;
        const reportTbtParameters: Report2_2Parameters = {
            userId: this.params.selectedUser.id,
            roleId: Number(this._scatterService.selectedRole),
            date: `${this.params.selDate.year}-${this.params.selDate.month}-${this.params.selDate.day}`,
            behaviourMetricID: this._scatterService.selectedBehavior,
            outcomeMetricID: this._scatterService.selectedOutcome,
        };
        this._reportService
            .retrieveReport2_2Data(reportTbtParameters)
            .pipe(
                tap((reportId) => {
                    if (reportId > 0) {
                        this._scatterService.userBehaviourTarget =
                            this.params.inputBehaviorTarget;
                        this._scatterService.userOutcomeTarget =
                            this.params.inputOutcomeTarget;
                        this._scatterService.selectedUser =
                            this.params.selectedUser.name;
                        this.generated.next(reportId);
                    } else {
                        this.params.noData = true;
                    }
                    // eslint-disable-next-line no-return-assign
                }),
                finalize(() => (this.params.pendingData = false)),
            )
            .subscribe();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedRole(value: any) {
        this._scatterService.selectedRole = value.value;
        this.params.notFound = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedOutcome(value: any) {
        this._scatterService.selectedOutcome = value.value;
        this._scatterService.selectedOutcomeName = value.label;
        this.outcomeModified = true;
        this.pendingOutcome = true;
        this.params.notFound = false;

        this.params.inputOutcomeTarget = '0.00';
        this.pendingOutcome = false;

        // let targetParams: TargetParameters = {
        //     metricId: value.value,
        //     date: `${this.params.selDate.year}-${this.params.selDate.month}-${this.params.selDate.day}`,
        //     roleId: this._scatterService.selectedRole,
        //     userId: String(this.params.selectedUser.id)
        // };

        // this._reportService.retrieveMetricTarget(targetParams).subscribe(r => {
        //     if (Object.keys(r).length) {
        //         this.params.inputOutcomeTarget = `${Number(r).toFixed(2)}`;
        //     } else {
        //         this.params.inputOutcomeTarget = '0.00';
        //     }
        //     this.pendingOutcome = false;
        // }),
        // catchError(error => {
        //     this.params.inputOutcomeTarget = '0.00';
        //     this.pendingOutcome = false;
        //     throw error;
        // });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedBehaviour(value: any) {
        this._scatterService.selectedBehavior = value.value;
        this._scatterService.selectedBehaviorName = value.label;
        this.params.notFound = false;
        this.pendingBehaviour = true;

        this.params.inputBehaviorTarget = '0.00';
        this.pendingBehaviour = false;

        // let targetParams: TargetParameters = {
        //     metricId: value.value,
        //     date: `${this.params.selDate.year}-${this.params.selDate.month}-${this.params.selDate.day}`,
        //     roleId: this._scatterService.selectedRole,
        //     userId: String(this.params.selectedUser.id)
        // };
        // this._reportService.retrieveMetricTarget(targetParams).subscribe(r => {
        //     if (Object.keys(r).length) {
        //         this.params.inputBehaviorTarget = `${Number(r).toFixed(2)}`;
        //     } else {
        //         this.params.inputBehaviorTarget = '0.00';
        //     }
        //     this.pendingBehaviour = false;
        // }),
        // catchError(error => {
        //     this.params.inputBehaviorTarget = '0.00';
        //     this.pendingOutcome = false;
        //     throw error;
        // });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedDate() {
        const validFormat = isValidDateStruct(this.params.selDate);
        this.params.invalidDate =
            !validFormat ||
            Util.dateToDate(this.params.selDate) <
                Util.dateToDate(this.minDate) ||
            Util.dateToDate(this.params.selDate) >
                Util.dateToDate(this.maxDate);
        if (!this.params.invalidDate) {
            this._scatterService.selectedDate = Util.dateToDate(
                this.params.selDate,
            ).toString();
            this.changed.next(true);
        }
        this.params.notFound = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    get minDate() {
        if (this.rawDates) {
            return Util.dateToNgbDate(new Date(this.rawDates.firstDate));
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    get maxDate() {
        if (this.rawDates) {
            return Util.dateToNgbDate(new Date(this.rawDates.lastDate));
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    enterBehaviourTarget(value) {
        this.params.inputBehaviorTarget = value.toString();
        this.params.notFound = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    enterOutcomeTarget(value) {
        this.params.inputOutcomeTarget = value.toString();
        this.params.notFound = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    get isDone() {
        const isDone =
            this.params.selectedUser != null &&
            this.params.selRole != null &&
            this.roleList.length > 0 &&
            this.params.selRole != null &&
            this.params.selDate != null &&
            this.params.selOutcome != null &&
            this.params.selBehaviour != null &&
            !this.params.invalidDate;
        return isDone;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    processData(data: Report2x2Result[]) {
        let resp = new Array<Report2x2Result>();
        resp = data.filter(
            (el) =>
                el.outcome &&
                el.behaviour &&
                el.outcome > 0 &&
                el.behaviour > 0,
        );
        return resp;
    }

    numberOnly(event): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode === 46) {
            return true;
        }

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
}
